export default "__VITE_ASSET__11f5a273__"